import React from 'react';
import PropTypes from 'prop-types';
import {Button, Message} from 'epic-diesel-common';
import {buttonTypes, priority} from 'epic-diesel-common/src/constants';
import Input from 'epic-diesel-form/src/components/form/Input';
import styles from './VerifyEmailSection.pcss';

const CHECK_VERIFICATION_DELAY_IN_MSEC = 10000;
// Check for 10 minutes, every {CHECK_VERIFICATION_DELAY_IN_MSEC} seconds
const CHECK_VERIFICATION_RETRIES = 600000 / CHECK_VERIFICATION_DELAY_IN_MSEC;

export default class VerifyEmailSection extends React.Component {
    static propTypes = {
        sectionData: PropTypes.object,
        influencerState: PropTypes.object,
        checkEmailVerification: PropTypes.func,
        checkingVerification: PropTypes.bool
    };
    static defaultProps = {
        sectionData: {},
        influencerState: {}
    };
    timer = null;
    timesChecked = 0;

    UNSAFE_componentWillReceiveProps(nextProps) {
        // don't do this when server-side rendering
        if (typeof window !== 'undefined' && this.timesChecked < CHECK_VERIFICATION_RETRIES) {
            const {checkingVerification} = nextProps;
            const {verificationSent} = nextProps.influencerState;

            if (verificationSent && !checkingVerification) {
                this.timer = setTimeout(
                    this.props.checkEmailVerification,
                    CHECK_VERIFICATION_DELAY_IN_MSEC
                );
                this.timesChecked++;
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const {sectionData, influencerState} = this.props;

        const {email} = sectionData;
        const {verificationSent} = influencerState;

        const buttonTextCode = verificationSent
            ? 'epic.affiliate.common.sent'
            : 'epic.affiliate.common.resend';

        return (
            <div className={styles.emailInfo} onLoad={this.startTimer}>
                <h2>
                    <Message code="epic.affiliate.signup.email_verification.title" />
                </h2>
                <p>
                    <Message code="epic.affiliate.signup.email_verification.text" />
                </p>
                <div className={styles.emailAccountInfoItem}>
                    <div className={styles.email}>
                        <Input type="email" name="email" value={email} disabled={true} />
                    </div>
                    <Button
                        priority={priority.PRIMARY}
                        type={buttonTypes.SUBMIT}
                        disabled={verificationSent}
                        theme="dark">
                        <Message code={buttonTextCode} />
                    </Button>
                </div>
            </div>
        );
    }
}
